import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const SEVERITY = {
  critical: {
    label: "Critical",
    text: "text-red-400",
    bg: "bg-red-500/10",
    border: "border-red-500/30",
    dot: "bg-red-500",
    ring: "#EF4444",
  },
  warning: {
    label: "Warning",
    text: "text-amber-400",
    bg: "bg-amber-500/10",
    border: "border-amber-500/30",
    dot: "bg-amber-500",
    ring: "#F59E0B",
  },
  info: {
    label: "Info",
    text: "text-sky-400",
    bg: "bg-sky-500/10",
    border: "border-sky-500/30",
    dot: "bg-sky-500",
    ring: "#3B82F6",
  },
};

export const CATEGORY_META = {
  "Windows OS": { color: "#06B6D4", short: "OS" },
  "MS Office Apps": { color: "#EA4335", short: "Office" },
  "MS Account / Activation": { color: "#6366F1", short: "Account" },
};
